// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2CF6F","selects":"Documents_selects__Qsu8E"};